import { ApiError } from './api';

/**
 * The message to show a person for a thrown value. `ApiError` carries the
 * server's own wording (validation detail, conflict reason); a network failure
 * is a bare `TypeError("Failed to fetch")`, which is worth rewording.
 */
export function messageOf(err: unknown, fallback: string): string {
  if (err instanceof ApiError) return err.message || fallback;
  if (err instanceof TypeError && /fetch/i.test(err.message)) {
    return 'Could not reach the server — check your connection and try again.';
  }
  if (err instanceof Error && err.message) return err.message;
  if (typeof err === 'string' && err) return err;
  return fallback;
}

/** True when `err` is an API response with this HTTP status. */
export function isApiStatus(err: unknown, status: number): err is ApiError {
  return err instanceof ApiError && err.status === status;
}
